import { render, staticRenderFns } from "./ClazzHeader.vue?vue&type=template&id=051d0d5a&scoped=true&"
import script from "./ClazzHeader.vue?vue&type=script&lang=js&"
export * from "./ClazzHeader.vue?vue&type=script&lang=js&"
import style0 from "./ClazzHeader.vue?vue&type=style&index=0&id=051d0d5a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051d0d5a",
  null
  
)

export default component.exports